// ============================================================================
// Error Messages for Technician Management Epic
// ============================================================================

/**
 * Error messages for Technician Management Epic
 * Contains validation errors and API error messages
 */
export const TECHNICIAN_ERROR_MESSAGES = {
  // Validation errors
  REQUIRED: 'To pole jest wymagane', // This field is required
  EMAIL_INVALID_FORMAT: 'Niepoprawny adres e-mail', // Invalid email address
  PHONE_MIN_LENGTH: 'Numer telefonu musi zawierać co najmniej 9 cyfr', // Phone number must contain at least 9 digits
  ZIP_INVALID_FORMAT: 'Nieprawidłowy format kodu pocztowego.', // Invalid postal code format

  // API errors
  DEFAULT_ERROR: 'Wystąpił błąd podczas dodawania technika', // An error occurred while adding technician
  NETWORK_ERROR: 'Coś poszło nie tak. Spróbuj ponownie.', // Something went wrong. Try again.
  UNEXPECTED_ERROR: 'Wystąpił nieoczekiwany błąd. Spróbuj ponownie.', // An unexpected error occurred. Try again.
  EMAIL_ALREADY_EXISTS: 'Ten adres e-mail jest już zarejestrowany', // This email address is already registered

  // File upload errors
  FILE_TOO_LARGE: 'File is too large (max 5MB)', // todo: translate
  INVALID_FILE_TYPE: 'Invalid file type', // todo: translate
  MAX_FILES_EXCEEDED: 'Maximum 2 document files', // todo: translate
  INVALID_FILENAME:
    'File names cannot contain "/", "\\", "?", "&", "%". Please rename the file and try again.', // todo: translate
} as const;
